/** GRS80 ellipsoid distance (same formula as A2 calcDistance). */
export function calcDistanceGRS80(lat1: number, lng1: number, lat2: number, lng2: number): number {
  const toRad = (d: number) => (d * Math.PI) / 180;
  const a = 6378137.0;
  const f = 1 / 298.257222101;
  const b = a * (1 - f);
  const p1 = toRad(lat1);
  const p2 = toRad(lat2);
  const l1 = toRad(lng1);
  const l2 = toRad(lng2);
  const P = (p1 + p2) / 2;
  const dP = p1 - p2;
  const dL = l1 - l2;
  const e2 = (a * a - b * b) / (a * a);
  const W = Math.sqrt(1 - e2 * Math.sin(P) * Math.sin(P));
  const M = (a * (1 - e2)) / (W * W * W);
  const N = a / W;
  const d = Math.sqrt((M * dP) * (M * dP) + (N * Math.cos(P) * dL) * (N * Math.cos(P) * dL));
  return Math.round((d / 1000) * 100) / 100; // km, 2 decimal
}
